<template>
	<div>
		<div v-if="cont" class="selected-tickets mt-0">
	        <label style="text-transform: uppercase">{{ !event.reserva_instalaciones ? $t('evento.entradas_seleccionadas') : $t('evento.reservas_seleccionadas') }}:</label>
	        <ul>
		        <template v-for="(entrada, index) in entradas">
		            <li :key="index" v-if="entrada.unidades > 0">
		                {{ ++index }}. {{ entrada.name }} x{{ entrada.unidades }}
		            </li>
		        </template>
	        </ul>
	        <div class="d-block d-md-flex justify-content-between align-items-center" v-if="! teatro.carrito_varios_eventos">
	        	<b-button class="btn btn-block" @click.prevent="continuar" :disabled="!paso_activo">{{ $t('partido.continuar_compra') }}</b-button>
			</div>
            <b-row v-else>
                <template v-if="!carrito || carrito.items_count == 0">
                    <b-col cols="9">
                        <b-button 
                            class="btn btn-block"
                            :disabled="!paso_activo"
                            @click="continuar"
                        >
                        {{ $t('partido.continuar_compra') }}
                        </b-button>
                    </b-col>
                    <b-col cols="3">
                        <b-button 
                            class="btn btn-block"
                            :disabled="!paso_activo || disableButtonCart"
                            @click="checkCarrito()"
                        >
                            <i class="fa fa-cart-plus" aria-hidden="true"></i>
                        </b-button>
                    </b-col>
                </template>
                <template v-else>
                    <b-col cols="12">
                        <b-button 
                            class="btn btn-block"
                            :disabled="!paso_activo || disableButtonCart"
                            @click="checkCarrito()"
                        >
                            {{ $t('carrito.añadir') }}
                        </b-button>
                    </b-col>
                </template>
            </b-row>
		</div>
    </div>
</template>

<script>
export default {
    props: ['entradas', 'siguiente', 'paso_activo', 'event'],
    data() {
        return {
            disableButtonCart: false,
        }
    },
    computed: {
        cont() {
            var cont = false;
            for(var i in this.entradas) {
                if(this.entradas[i].unidades > 0) {
                    cont = true;
                }
            }

            return cont;
        },
        footer() {
            return this.$store.getters.getFooter;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        carrito() {
            return this.$store.getters.getCarritoActivoOnline;
        },
    },
    methods: {
        continuar() {
            this.$emit('continuar');
        },
        checkCarrito() {
            if (this.carrito) {
                this.setItemsCarrito();
            } else {
                this.crearCarrito();
            }
        },
        async crearCarrito() {
            const params = { filters: {}, uuid: localStorage.getItem('uuid') };

            return this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.crear'), params).then(res => {
                this.setItemsCarrito();
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        },
        async setItemsCarrito() {
            this.disableButtonCart = true;
            
            const params = {
                filters: {uuid: localStorage.getItem('uuid')},
                cart_id: this.carrito?.id,
                plazas: [],
                asientos: this.getAsientosFormatted()
            };

            this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.add-items'), params).then(res => {
                this.$toast.success('Entradas añadidas al carrito correctamente.');
                this.$store.dispatch('USUARIO_CARRITO_ACTIVO', {filters:{ uuid: localStorage.getItem('uuid')}});
                this.$router.push({path: "/eventos"});
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            }).finally(() => {
                this.disableButtonCart = false;
            });
        },
        getAsientosFormatted() {
            let asientos = [];
            this.entradas.map(entrada => {
                asientos.push({
                    precio: {
                        id: entrada.id
                    },
                    units: entrada.unidades,
                    event_id: this.$route.params.event_id,
                    event_session_id: this.$route.params.sesion_id
                })
            });
            return asientos;
        },
    },
}
</script>

<style>

</style>
